import React, { Component } from 'react'
import styled from 'styled-components'

import {IconTwitter, IconFacebook, IconInstagram, IconLinkedin} from './socialIcons.js'

export default class Footer extends Component {
  render() {
    return (
      <FooterWrapper>
        <Column>
          <ColumnTitle>First Step Coding</ColumnTitle>
          <ColumnText>
            <MenuLink href='/terms'>Terms of Service</MenuLink>
            <MenuLink href='/privacy'>Privacy Policy</MenuLink>
          </ColumnText>
          <Icons>
            <MenuLink href='https://www.twitter.com/firststepcoding/' target='_blank'>
              <IconWrapper><IconTwitter /></IconWrapper>
            </MenuLink>
            <MenuLink href='https://www.facebook.com/yourfirststepcoding/' target='_blank'>
              <IconWrapper><IconFacebook /></IconWrapper>
            </MenuLink>
            <MenuLink href='https://www.instagram.com/yourfirststepcoding/' target='_blank'>
              <IconWrapper><IconInstagram /></IconWrapper>
            </MenuLink>
            <MenuLink href='https://www.linkedin.com/company/15242127/' target='_blank'>
              <IconWrapper><IconLinkedin /></IconWrapper>
            </MenuLink>
          </Icons>
        </Column>

        <Column>
          <ColumnTitle>Get Started</ColumnTitle>
          <ColumnText>
            <MenuLink href='/apply' >Apply Now</MenuLink>
            {/* <MenuLink
              id='syllabus-link'
              href='/resources/syllabi/First_Step_Coding-Intro_to_Coding_in_JavaScript-Syllabus.pdf'
              target='_blank'
            >
              View Syllabus</MenuLink> */}
          </ColumnText>
        </Column>

        <Column>
          <ColumnTitle>Courses</ColumnTitle>
          <ColumnText>
            <MenuLink href='/intro-to-coding'>Intro to Coding</MenuLink>
            <MenuLink href='/bootcamp-prep'>Bootcamp Prep</MenuLink>
            <MenuLink href='/instructors'>Instructors</MenuLink>
            <MenuLink href='/faq'>F.A.Q.</MenuLink>
          </ColumnText>
        </Column>

        <Column>
          <ColumnTitle>Company</ColumnTitle>
          <ColumnText>
            {/* <MenuLink href='/bootcamp-partners'>Partners</MenuLink> */}
            <MenuLink href='/contact-us'>Contact Us</MenuLink>
            <MenuLink href='https://angel.co/firststepcoding/jobs' target='_blank'>Careers</MenuLink>
            <MenuLink href='/blog'>Blog</MenuLink>
          </ColumnText>
        </Column>
      </FooterWrapper>
    )
  }
}

const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding: 60px 0;
  background-color: black;
  color: white;
  font-family: Raleway;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 160px;
  padding: 0 15px;

  &:first-child {
    max-width: 210px;
  }

  @media only screen and (max-width: 767px) {
    align-items: center;
    margin-bottom: 24px;
  }
`

const ColumnTitle = styled.div`
  margin-bottom: 30px;
  font-weight: 300;
  font-size: 22px;
  line-height: 32px;

  @media only screen and (max-width: 767px) {
    margin-bottom: 16px;
    font-size: 18px;
    line-height: 24px;
  }
`

const ColumnText = styled.div`
  display: flex;
  flex-direction: column;
  opacity: 0.7;
  font-weight: 300;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;

  @media only screen and (max-width: 767px) {
    align-items: center;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 10px;
  }
`

const MenuLink = styled.a`
  color: white;
  font-family: Raleway;
  transition: all 0.2s;

  &:hover {
    color: #3D9991;
  }
`

const Icons = styled.div`
  margin-top: 16px;
  opacity: 1;
`

const IconWrapper = styled.span`
  margin-right: 8px;
`
